module.exports = __webpack_public_path__ + "toolkit-entypo.08d9ab2292c81ae41edc.woff2";


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/src/assets/fonts/toolkit-entypo.woff2
// module id = ../../../../../src/assets/fonts/toolkit-entypo.woff2
// module chunks = 3